import React, { useState, useEffect } from 'react'
import { Icon } from '../../elements'

import './ThemeToggler.scss'

export const ThemeToggler = () => {
    const [checked, setChecked] = useState(document.documentElement.classList.contains("dark-mode") || localStorage.getItem("theme") === "dark-mode")

    useEffect(() => {
        setChecked(document.documentElement.classList.contains("dark-mode") || localStorage.getItem("theme") === "dark-mode")
    }, [document.documentElement.classList.contains("dark-mode"), localStorage.getItem("theme")])

    const onChange = () => {
        document.documentElement.classList.toggle("dark-mode")
        localStorage.setItem("theme", document.documentElement.classList.contains("dark-mode") ? "dark-mode" : null)
        setChecked(document.documentElement.classList.contains("dark-mode"))
    }

    return (
        <div className='ThemeToggler'>
            <label className="toggle-label">
                <input type="checkbox" checked={checked} onChange={onChange} />
                <div className="toggle-switch">
                    <div className="toggle-switch-icon">
                        <Icon src="/assets/icons/sun.svg" className="toggle-icon" />
                        <Icon src="/assets/icons/moon.svg" className="toggle-icon" />
                    </div>
                </div>
            </label>
        </div>
    )
}